import { render, staticRenderFns } from "./createQuestion.vue?vue&type=template&id=7e5b5c4d"
import script from "./createQuestion.vue?vue&type=script&lang=js"
export * from "./createQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports